import { Component, OnInit } from '@angular/core';
import { DashboardCustomerKPIService } from '../../../services';
import { EventService } from '../../../services';
import { ChartDataset } from '../../../interfaces/kpis/customer-kpi-totals';

@Component({
  selector: 'dashboard-customer-kpi-service-levels',
  templateUrl: './dashboard-customer-kpi-servicelevels.component.html',
  styleUrls: ['./dashboard-customer-kpi-display.component.scss'],
})
export class DashboardCustomerKPIServiceLevelsComponent implements OnInit {
  constructor(
    private dashboardKPIService: DashboardCustomerKPIService,
    private eventService: EventService,
  ) {}

  // pass to display component as Input
  metrics: any[];
  gradeColours: string[];

  async ngOnInit() {
    console.log('Loaded service levels component');

    this.gradeColours = this.dashboardKPIService.getInverseGradeColours4();

    this.eventService.CustomerKPIRefreshEvent.subscribe(() => {
      this.loadData();
    });
  }

  async loadData() {
    this.metrics = [];

    this.setServiceLevelMetrics_Collection();
    this.setServiceLevelMetrics_Delivery();

    //await this.setServiceLevelMetrics();
  }

  setServiceLevelMetrics_Collection() {
    let datas: ChartDataset[] = [
      {
        label: 'Completed',
        data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
        backgroundColor: 'rgba(66, 164, 245, 1)',
        type: 'line',
      },
      {
        label: 'On Time Collection',
        data: this.dashboardKPIService.completedTotals.map((x) => x.onTimeCollection),
        backgroundColor: this.gradeColours[0],
      },
      {
        label: 'Less Than 1 Hour Late (Collection)',
        data: this.dashboardKPIService.completedTotals.map((x) => x.lessThan1HourLateCollection),
        backgroundColor: this.gradeColours[1],
      },
      {
        label: 'Later Same Day Collection',
        data: this.dashboardKPIService.completedTotals.map((x) => x.laterSameDayCollection),
        backgroundColor: this.gradeColours[2],
      },
      {
        label: 'Next Day Or Later (Collection)',
        data: this.dashboardKPIService.completedTotals.map((x) => x.nextDayOrLaterCollection),
        backgroundColor: this.gradeColours[3],
      },
      // { label: "Timed Appointments %", data: this.dashboardKPIService.completedTotals.map(x => {
      //         return x.completedMoves == 0 ? 0 : (x.timedAppointments.filter((ta, index) => index < 3).reduce((a, b) => a + b) / x.completedMoves) * 100.0
      //     }), backgroundColor: 'rgba(35,47,93, 0.9)', hideInChart: true, isPercentCol: true }
    ];

    // filter out datas with no value
    datas = this.dashboardKPIService.filterZeroData(datas);

    let labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
    let metric = this.dashboardKPIService.getServiceMetricData(
      'Service Levels (Collection)',
      datas,
      labels,
      true,
      this.dashboardKPIService.stackedChartOptions,
    );

    //console.log("Time window metric: ", metric);

    this.metrics.push(metric);
  }

  setServiceLevelMetrics_Delivery() {
    let datas: ChartDataset[] = [
      {
        label: 'Completed',
        data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
        backgroundColor: 'rgba(66, 164, 245, 1)',
        type: 'line',
      },
      {
        label: 'On Time Delivery',
        data: this.dashboardKPIService.completedTotals.map((x) => x.onTimeDelivery),
        backgroundColor: this.gradeColours[0],
      },
      {
        label: 'Less Than 1 Hour Late (Delivery)',
        data: this.dashboardKPIService.completedTotals.map((x) => x.lessThan1HourLateDelivery),
        backgroundColor: this.gradeColours[1],
      },
      {
        label: 'Later Same Day Delivery',
        data: this.dashboardKPIService.completedTotals.map((x) => x.laterSameDayDelivery),
        backgroundColor: this.gradeColours[2],
      },
      {
        label: 'Next Day Or Later (Delivery)',
        data: this.dashboardKPIService.completedTotals.map((x) => x.nextDayOrLaterDelivery),
        backgroundColor: this.gradeColours[3],
      },
      // { label: "Timed Appointments %", data: this.dashboardKPIService.completedTotals.map(x => {
      //         return x.completedMoves == 0 ? 0 : (x.timedAppointments.filter((ta, index) => index < 3).reduce((a, b) => a + b) / x.completedMoves) * 100.0
      //     }), backgroundColor: 'rgba(35,47,93, 0.9)', hideInChart: true, isPercentCol: true }
    ];

    // filter out datas with no value
    datas = this.dashboardKPIService.filterZeroData(datas);

    let labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
    let metric = this.dashboardKPIService.getServiceMetricData(
      'Service Levels (Delivery)',
      datas,
      labels,
      true,
      this.dashboardKPIService.stackedChartOptions,
    );

    //console.log("Time window metric: ", metric);

    this.metrics.push(metric);
  }

  async setServiceLevelMetrics() {
    await this.setMetric(0);
    await this.setMetric(1);
    await this.setMetric(2);
    await this.setMetric(3);
  }

  async setMetric(index) {
    let labels: any;
    let metric: any;

    switch (index) {
      case 0:
        // on time
        let datas: ChartDataset[] = [
          {
            label: 'Completed',
            data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
            backgroundColor: 'rgba(66, 164, 245, 1)',
            type: 'line',
          },
          {
            label: 'On Time Collection',
            data: this.dashboardKPIService.completedTotals.map((x) => x.onTimeCollection),
            backgroundColor: 'rgba(0, 201, 44, 0.9)',
          },
          {
            label: 'On Time Delivery',
            data: this.dashboardKPIService.completedTotals.map((x) => x.onTimeDelivery),
            backgroundColor: 'rgba(0, 201, 168, 0.9)',
          },
        ];
        labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
        metric = this.dashboardKPIService.getServiceMetricData(
          'On Time',
          datas,
          labels,
          true,
          this.dashboardKPIService.baseChartOptions,
        );

        break;
      case 1:
        // < 1 hour late
        datas = [
          {
            label: 'Completed',
            data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
            backgroundColor: 'rgba(66, 164, 245, 1)',
            type: 'line',
          },
          {
            label: 'Less Than 1 Hour Late (Collection)',
            data: this.dashboardKPIService.completedTotals.map(
              (x) => x.lessThan1HourLateCollection,
            ),
            backgroundColor: 'rgba(0, 201, 168, 0.9)',
          },
          {
            label: 'Less Than 1 Hour Late (Delivery)',
            data: this.dashboardKPIService.completedTotals.map((x) => x.lessThan1HourLateDelivery),
            backgroundColor: 'rgba(0, 201, 44, 0.9)',
          },
        ];
        labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
        metric = this.dashboardKPIService.getServiceMetricData(
          'Less Than 1 Hour Late',
          datas,
          labels,
          true,
          this.dashboardKPIService.baseChartOptions,
        );
        break;
      case 2:
        // over 1 hour late but same day
        datas = [
          {
            label: 'Completed',
            data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
            backgroundColor: 'rgba(66, 164, 245, 1)',
            type: 'line',
          },
          {
            label: 'Later Same Day Collection',
            data: this.dashboardKPIService.completedTotals.map((x) => x.laterSameDayCollection),
            backgroundColor: 'rgba(0, 60, 201, 0.9)',
          },
          {
            label: 'Later Same Day Delivery',
            data: this.dashboardKPIService.completedTotals.map((x) => x.laterSameDayDelivery),
            backgroundColor: 'rgba(201,0,87, 0.9)',
          },
        ];
        labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
        metric = this.dashboardKPIService.getServiceMetricData(
          'Later Same Day',
          datas,
          labels,
          true,
          this.dashboardKPIService.baseChartOptions,
        );
        break;
      case 3:
        // next day or later
        datas = [
          {
            label: 'Completed',
            data: this.dashboardKPIService.completedTotals.map((x) => x.completedMoves),
            backgroundColor: 'rgba(66, 164, 245, 1)',
            type: 'line',
          },
          {
            label: 'Next Day Or Later (Collection)',
            data: this.dashboardKPIService.completedTotals.map((x) => x.nextDayOrLaterCollection),
            backgroundColor: 'rgba(219, 20, 106, 0.9)',
          },
          {
            label: 'Next Day Or Later (Delivery)',
            data: this.dashboardKPIService.completedTotals.map((x) => x.nextDayOrLaterDelivery),
            backgroundColor: 'rgba(20, 219, 216, 0.9)',
          },
        ];
        labels = this.dashboardKPIService.completedTotals.map((x) => x.dateLabel);
        metric = this.dashboardKPIService.getServiceMetricData(
          'Next Day Or Later',
          datas,
          labels,
          true,
          this.dashboardKPIService.baseChartOptions,
        );
        break;
    }

    this.metrics.push(metric);
  }
}
